import { CheckCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './PaymentReleasedChatAlert.scss';

type PaymentReleasedChatAlertProps = {
	onFundsReceivedClick: () => void;
	disabled?: boolean;
};

function PaymentReleasedChatAlert({ onFundsReceivedClick, disabled }: PaymentReleasedChatAlertProps) {
	const { t } = useTranslation();

	return (
		<div className='chat-payment-released-alert'>
			<CheckCircleOutlined className='chat-payment-released-alert__icon' />
			<div className='chat-payment-released-alert__content'>
				<p className='chat-payment-released-alert__title'>{t<string>('paymentReleasedAlertTitle')}</p>
				<p className='chat-payment-released-alert__description'>{t<string>('paymentReleasedAlertDescription')}</p>
				<button
					type='button'
					className='chat-payment-released-alert__button'
					disabled={disabled}
					onClick={onFundsReceivedClick}
				>
					{t<string>('fundsReceived')}
				</button>
			</div>
		</div>
	);
}

export default PaymentReleasedChatAlert;
